import $ from 'jquery';
import * as Bootstrap from 'bootstrap'

window.jQuery = window.$ = $
window.bootstrap = Bootstrap;
